import React, {useEffect} from 'react'
import { Menu, Typography } from 'antd';
import {
    UserAddOutlined,
    LogoutOutlined,
    UserOutlined,
  } from '@ant-design/icons';
import { useHistory, useLocation } from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux';
import {userActions} from '../../redux/reducers/user'
import { profileActions } from '../../redux/reducers/userProfile';
import { orderActions } from '../../redux/reducers/order';

const { Text } = Typography;
const HeaderMenu = () => {
const user = useSelector(state => state.user)
  const dispatch = useDispatch();
  const location = useLocation()
  const history = useHistory()

  const onMenuClick =(path)=>{
      history.push(path);
  }

  useEffect(() => {
      if(user.jwt){
        dispatch(profileActions.getProfile(user.jwt))
        dispatch(orderActions.getOrders(user.jwt))
      }
  }, [user.jwt])

  if(user.jwt){
    return (
        <Menu theme="light" selectedKeys={[location.pathname]}  mode="horizontal">
          <Menu.Item key="/logout" 
              style={{float:"right"}}
              onClick={() => {dispatch(userActions.logOut())}}
              icon={<LogoutOutlined />}
          >
              Sign Out
          </Menu.Item>
          <Menu.Item 
              key="/profile"
              style={{float:"right"}}
              onClick={() => onMenuClick('/profile')}
              icon={<UserOutlined />}
          >
              Profile
          </Menu.Item>
      </Menu>
    );
  }else{
    return (
        <Menu theme="light" selectedKeys={[location.pathname]}  mode="horizontal">
          <Menu.Item key="/signin" 
              style={{float:"right"}}
              onClick={() => onMenuClick('/signin')}
              icon={<LogoutOutlined />}
          >
              Sign In
          </Menu.Item>
          <Menu.Item 
              key="/register"
              style={{float:"right"}}
              onClick={() => onMenuClick('/register')}
              icon={<UserAddOutlined />}
          >
              Register
          </Menu.Item>
      </Menu>
    );
  }
}

export default HeaderMenu